import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";
import { Dropdown } from "semantic-ui-react";
import ReactGA from "react-ga";
import moment from "moment";

import OSCard from "../../OSCard/OSCard";

import { translate, getLanguage } from "../../Translation/Translation";
import { FETCH_URL } from "../../../utilities";

class AllEventsContent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      all: [],
      events: [],
      events2: [],
      eventstype: [],
      departure: [],
      activeOutPage: 1,
      activeInPage: 1,
      loading: false,
    };
  }

  handlePageChangeIn = (pageNumber) => {
    this.setState({ activeInPage: pageNumber });
  };

  handlePageChangeOut = (pageNumber) => {
    this.setState({ activeOutPage: pageNumber });
  };

  fetchDeparture = () => {
    fetch(
      `${FETCH_URL}/proxy.php?ws=358831c718affbe0536608ebd7b8572a/${getLanguage()}`,
      {
        method: "GET",
      }
    )
      .then((response) => response.json())
      .then((responseJson) => {
        this.setState({ departure: responseJson });
        return responseJson;
      })
      .catch((error) => {
        console.error(error);
      });
  };

  fetchEventsType = () => {
    fetch(
      `${FETCH_URL}/proxy.php?ws=b71b5e097b885d9929e72f88b07361ee/${getLanguage()}`,
      {
        method: "GET",
      }
    )
      .then((response) => response.json())
      .then((responseJson) => {
        this.setState({ eventstype: responseJson });
        return responseJson;
      })
      .catch((error) => {
        console.error(error);
      });
  };

  fetchEvents(locationCode, eventTypeId, maxEventsSize, date) {
    fetch(`${FETCH_URL}/proxy.php?ws=3624a2d36f2aa7035e6160b3997480d8`, {
      method: "POST",
      body: JSON.stringify({
        languageCode: `${getLanguage()}`,
        locationCode: locationCode,
        eventTypeId: eventTypeId,
        maxEventsSize: maxEventsSize,
        date: date,
      }),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        this.setState({ events: responseJson.events });
        return responseJson;
      })
      .catch((error) => {
        console.error(error);
      });
  }
  componentDidMount() {
    this.fetchDeparture();
    this.fetchEventsType();
    this.fetchEvents(
      this.props.events.locationCode,
      this.props.events.eventTypeId,
      this.props.events.maxEventsSize,
      this.props.events.date
    );
  }

  eventsTypeChanged = (target) => {
    let newdate = new Date();
    if (this.props.events.eventTypeId !== target.value) {
      this.fetchEvents(
        this.props.events.locationCode,
        target.value,
        this.props.events.maxEventsSize,
        this.props.events.date
      );
      this.props.setTypeId(target.value);
      this.setState({ activeOutPage: 1 });
    }

    ReactGA.event({
      category: "Events",
      action: "searchSpecificEvent(with TypeID)",
      label: `${moment(newdate).format("YYYYMMDD")}#${moment(newdate).format(
        "hhmm"
      )}#0#${target.value}#2b735297-625f-412f-8bd0-6a6498d494e0`,
    });
  };

  placeChanged = (target) => {
    let newdate = new Date();
    if (this.props.events.locationCode !== target.value) {
      this.fetchEvents(
        target.value,
        this.props.events.eventTypeId,
        this.props.events.maxEventsSize,
        this.props.events.date
      );
      this.props.setLocationCode(target.value);
    }

    ReactGA.event({
      category: "Events",
      action: "searchSpecificEvent(with LocationID)",
      label: `${moment(newdate).format("YYYYMMDD")}#${moment(newdate).format(
        "hhmm"
      )}#${target.value}#0#2b735297-625f-412f-8bd0-6a6498d494e0#2104675081`,
    });
  };

  render() {
    const { loading } = this.state;

    if (loading) {
      return null;
    }

    let departure = [];
    departure = this.state.departure.map((dep) => {
      return { key: dep.id, text: dep.name, value: dep.code };
    });
    departure.unshift({
      key: 0,
      text: translate(getLanguage(), "All Destinations"),
      value: 0,
    });

    let eventstype = [];
    eventstype = this.state.eventstype.map((type) => {
      return { key: type.id, text: type.name, value: type.id };
    });
    eventstype.unshift({
      key: 0,
      text: translate(getLanguage(), "All Event Types"),
      value: 0,
    });

    const events = this.state.events.map((event) => {
      return (
        <Col xs={12} sm={6} lg={4} key={event.id}>
          <OSCard
            key={event.id}
            id={event.id}
            image={event.imageUrl}
            title={event.eventName}
            link={event.link}
            startDate={event.eventVenues[0].startDate}
            endDate={event.eventVenues[0].endDate}
            venueName={event.eventVenues[0].venueName}
            description={event.description}
            lat={event.eventVenues[0].latitude}
            lng={event.eventVenues[0].longitude}
          />
        </Col>
      );
    });

    return (
      <div>
        {this.state.events.length > 0 ? (
          <div>
            <Row
              style={{
                margin: "0px 0px 20px 0px",
                padding: "0px",
                textAlign: "center",
                background: "white",
                display: "block",
              }}
            >
              <Dropdown
                className="filterDrop"
                value={this.props.events.locationCode}
                style={{ margin: "0px 10px" }}
                placeholder={translate(getLanguage(), "All Destinations")}
                selection
                options={departure}
                onChange={(event, target) => this.placeChanged(target)}
              />
              <Dropdown
                className="filterDrop"
                value={this.props.events.eventTypeId}
                style={{ margin: "0px 10px" }}
                placeholder={translate(getLanguage(), "All Event Types")}
                selection
                options={eventstype}
                onChange={(event, target) => this.eventsTypeChanged(target)}
              />
            </Row>
            <Row style={{ margin: "0px", textAlign: "center" }}>{events}</Row>
          </div>
        ) : (
          <div>
            <Row
              style={{
                margin: "0px 0px 20px 0px",
                padding: "0px",
                textAlign: "center",
                background: "white",
                display: "block",
              }}
            >
              <Dropdown
                className="filterDrop"
                value={this.props.events.locationCode}
                style={{ margin: "0px 10px" }}
                placeholder={translate(getLanguage(), "All Destinations")}
                selection
                options={departure}
                onChange={(event, target) => this.placeChanged(target)}
              />
              <Dropdown
                className="filterDrop"
                value={this.props.events.eventTypeId}
                style={{ margin: "0px 10px" }}
                placeholder={translate(getLanguage(), "All Event Types")}
                selection
                options={eventstype}
                onChange={(event, target) => this.eventsTypeChanged(target)}
              />
            </Row>
            <Row className="loader" style={{ margin: "0px" }}>
              <h1>Events not Found</h1>
            </Row>
          </div>
        )}
      </div>
    );
  }
}

export default AllEventsContent;



// WEBPACK FOOTER //
// ./src/components/Pages/Allevents/AllEventsContent.js